// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BRL currency input: same typography as design, placeholder gray */
.a9Vpg8 input {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md, 14px);
  line-height: 180%;
  color: var(--text-neutral-dark-gray, #1f1f1f);
}

.a9Vpg8 input::placeholder {
  color: var(--text-neutral-strong-gray, #999999);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/CurrencyInput/CurrencyInput.module.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,oCAAoC;EACpC,uCAAuC;EACvC,oCAAoC;EACpC,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["/* BRL currency input: same typography as design, placeholder gray */\n.currencyBRL input {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md, 14px);\n  line-height: 180%;\n  color: var(--text-neutral-dark-gray, #1f1f1f);\n}\n\n.currencyBRL input::placeholder {\n  color: var(--text-neutral-strong-gray, #999999);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currencyBRL": `a9Vpg8`
};
module.exports = ___CSS_LOADER_EXPORT___;
